export default {
	rule: null,
	term: JSON.parse(localStorage.getItem('term')) || null
}
